<div class="d-flex justify-content-between align-items-center mr-2">
    <div class="phone-container">
        <mat-form-field class="dial-code-field" appearance="outline">
            <mat-select [(value)]="paisSelected" (selectionChange)="setDialCode()" [disabled]="disabledComponent()"
                matTooltip="{{paisSelected?.name}} +{{paisSelected?.dialCode}}">
                <mat-select-trigger>
                    <img *ngIf="paisSelected" [src]="paisSelected.urlImage" height="13" />
                </mat-select-trigger>

                <mat-option *ngFor="let pais of paises" [value]="pais">
                    <img [src]="pais.urlImage"> {{pais.name}} +{{pais.dialCode}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="phone-field"  appearance="outline">
            <mat-label>Celular</mat-label>
            <input matInput type="text" [formControl]="control" inputmode="numeric" [attr.key]="maskPhone"
                [mask]="maskPhone" (focus)="inputTelefoneFocused()" (blur)="inputTelefoneBlur()"
                 (ngModelChange)="inputTelefoneChange()" />
        </mat-form-field>
    </div>
</div>